import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ContactprofileComponent } from './contact-profile.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


const routes: Routes = [{
	path: '',
	data: {
      title: 'Contact Profile',
      urls: [{title: 'Dashboard',url: '/'},{title: 'Contact Profile page'}]
    },
	component: ContactprofileComponent
}];

@NgModule({
	imports: [
    	FormsModule,
    	CommonModule, 
		NgbModule.forRoot(),
    	RouterModule.forChild(routes)
    ],
	declarations: [ContactprofileComponent]
})
export class ContactprofileModule { }


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/contact/contact-profile/contact-profile.module.ts